const partyPrefix = "/api/v1/party";

const partyType = "party";

const partyUrls = {
  steamplayer: {
    path: (name, id, pageNum, page, token) => {
      return `/players?name=${name}&id=${id}&num=${pageNum}&page=${page}&token=${token || ""}`;
    },
    method: "GET"
  },
  testingplayer: {
    path: (name, id, pageNum, page) => {
      return `/testingrecharge/records?name=${name}&id=${id}&num=${pageNum}&page=${page}`;
    },
    method: "GET"
  },
  refundTestingRecharge: {
    path: (id) => {
      return `/testingrecharge/refund/${id}`;
    },
    method: "GET"
  },
  steamplayerInfo: {
    path: (id) => {
      return `/player/${id}`;
    },
    method: "GET"
  },
  steamplayerInfoCache: {
    path: (id) => {
      return `/player/${id}/cache`;
    },
    method: "GET"
  },
  steamplayerItem: {
    path: (id) => {
      return `/player/${id}/items`;
    },
    method: "GET"
  },
  steamplayerItemCache: {
    path: (id) => {
      return `/player/${id}/items/cache`;
    },
    method: "GET"
  },
  steamplayerPuchase: {
    path: (id) => {
      return `/player/${id}/shopbuy`;
    },
    method: "GET"
  },
  steamplayerPassport: {
    path: (id) => {
      return `/player/${id}/passports`;
    },
    method: "GET"
  },
  playerTasks: {
    path: (id) => {
      return `/player/${id}/tasks`;
    },
    method: "GET",
  },
  playerAchvs: {
    path: (id) => {
      return `/player/${id}/achvs`;
    },
    method: "GET",
  },
  playerAchvsCache: {
    path: (id) => {
      return `/player/${id}/achvs/cache`;
    },
    method: "GET",
  },
  steamplayerRecharge: {
    path: (id) => {
      return `/player/${id}/orders`;
    },
    method: "GET"
  },
  batchFixed: {
    path: "/batchfix",
    method: "GET"
  },
  steamplayerVip: {
    path: (id) => {
      return `/player/${id}/vips`;
    },
    method: "GET"
  },
  bossMaterials: {
    path: (id) => {
      return `/player/${id}/bossmaterials`;
    },
    method: "GET"
  },
  playerEquipment: {
    path: (id) => {
      return `/player/${id}/eqs`;
    },
    method: "GET"
  },
  playerEquipmentCache: {
    path: (id) => {
      return `/player/${id}/eqs/cache`;
    },
    method: "GET"
  },
  playerEqPage: {
    path: (id) => {
      return `/player/${id}/eqpages`;
    },
    method: "GET"
  },
  playerEqPageCache: {
    path: (id) => {
      return `/player/${id}/eqpages/cache`;
    },
    method: "GET"
  },
  steamplayerHero: {
    path: (id) => {
      return `/player/${id}/heroes`;
    },
    method: "GET"
  },
  steamplayerHeroCache: {
    path: (id) => {
      return `/player/${id}/heroes/cache`;
    },
    method: "GET"
  },
  steamplayerBuff: {
    path: (id) => {
      return `/player/${id}/buffs`;
    },
    method: "GET"
  },
  steamplayerBuffCache: {
    path: (id) => {
      return `/player/${id}/buffs/cache`;
    },
    method: "GET"
  },
  steamplayerChickens: {
    path: (id) => {
      return `/player/${id}/chks`;
    },
    method: "GET"
  },
  steamplayerChickensCache: {
    path: (id) => {
      return `/player/${id}/chks/cache`;
    },
    method: "GET"
  },
  steamplayerSteelTree: {
    path: (id) => {
      return `/player/${id}/steeltree`;
    },
    method: "GET"
  },
  steamplayerSteelTreeCache: {
    path: (id) => {
      return `/player/${id}/steeltree/cache`;
    },
    method: "GET"
  },
  playerChickenSkills: {
    path: (id) => {
      return `/player/${id}/chkskills`;
    },
    method: "GET"
  },
  playerChickenSkillsCache: {
    path: (id) => {
      return `/player/${id}/chkskills/cache`;
    },
    method: "GET"
  },
  playerLootProgress: {
    path: (id) => {
      return `/player/${id}/lootcnt`;
    },
    method: "GET"
  },
  createActiveCode: {
    path: "/activecode",
    method: "POST",
  },
  getActiveCodeStatus: {
    path: "/activecode/status",
    method: "GET",
  },
  updateActiveCodeStatus: {
    path: "/activecode/status",
    method: "POST",
  },
  bannedList: {
    path: "/banned/detail",
    method: "GET"
  },
  createBannedList: {
    path: "/banned/detail",
    method: "POST"
  },
  deleteBannedDetail: {
    path: "/banned/detail/delete",
    method: "POST"
  },
  specialList: {
    path: "/specialusers",
    method: "GET"
  },
  createSpecialList: {
    path: "/specialusers",
    method: "POST"
  },
  deleteSpecialDetail: {
    path: (id) => { return `/specialusers/${id}` },
    method: "GET"
  },
  addBlackList: {
    path: "/admin/blacklist",
    method: "POST"
  },
  getPlayerLogs: {
    path: (id) => {
      return `/player/${id}/logs`;
    },
    method: "GET"
  },
  getPlayerPreLogs: {
    path: (id) => {
      return `/player/${id}/prelogs`;
    },
    method: "GET"
  },
  chargeStatistias: {
    path: "/charge/statistics",
    method: "GET"
  },
  apiStatistics: {
    path: "/api/statistics",
    method: "GET"
  },
  unhandleorder: {
    path: (start, end) => {
      return `/charge/unhandlerorder?start=${start}&end=${end}`;
    },
    method: "GET"
  },
  getAllShopItem: {
    path: "/shop/items",
    method: "GET"
  },
  makeShopTicket: {
    path: "/shop/ticket",
    method: "POST"
  },
  getShopTicketDetail: {
    path: "/shop/ticket/detail",
    method: "GET"
  },
  closeVerifyCode: {
    path: "/admin/verifycode/status",
    method: "GET"
  },
  clearPlayerRedisCache: {
    path: (id) => `/player/${id}/clearcache`,
    method: "GET"
  },
  recentlyOrder: {
    path: "/charge/recently",
    method: "GET"
  },
  takeShopTicket: {
    path: "/shop/ticket/collect",
    method: "POST"
  },
  crDailyReport: {
    path: (start, end) => `/daily/statistics?start=${start}&end=${end}`,
    method: "GET"
  },
  shopDailyReport: {
    path: (start, end) => `/shop/dailyreport?start=${start}&end=${end}`,
    method: "GET"
  },
  deletePlayer: {
    path: (id) => `/player/${id}`,
    method: "DELETE"
  },
  activePlayer: {
    path: (id) => `/player/${id}/active`,
    method: "GET"
  },
  playerRank: {
    path: (ppId) => `/leaderboard/player/${ppId}`,
    method: "GET"
  },
  playerLevelDetail: {
    path: (ppId) => `/leaderboard/detail/${ppId}`,
    method: "GET"
  },
  getSeasonRank: {
    path: "/leaderboard/season",
    method: "POST",
  },
  createSeasonRank: {
    path: "/leaderboard/season",
    method: "GET",
  },
  getMatchStatistics: {
    path: (type) => {
      return `/match/statistics/${type}`;
    },
    method: "GET"
  }
}

export { partyPrefix, partyUrls, partyType }
